import {db} from "@/firebase/init"

export default {
    data () {
        return {
            upcomingAdmins: [],
        }
    },
    computed: {
    },
    methods: {
        async getUpcomingAdminsV2(){
            try{
                const {data} = await this.$http.post("utilities/get-upcoming-admins", {
                    grant_type: 'token'
                })
                this.upcomingAdmins = data.upcomingAdmins
            }
            catch (e){
                console.log(e.toString(), 'Error in fetching upcoming admins')
            }
        }
    }
}
